module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@5.8.38@babel-runtime/core-js/array/from.js
// module id = 112
// module chunks = 0